import { Box, Card, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { useSettingsContext } from '../../components/settings';
import { Breadcrumbs } from './Breadcrumbs';
import { FosterFamilyListNavigatorContextProvider } from './FosterFamilyListNavigatorContext';
import { Tabs } from './Tabs';

export const FosterFamilyListNavigator = () => {
  const { themeStretch } = useSettingsContext();

  return (
    <FosterFamilyListNavigatorContextProvider>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Breadcrumbs />

        <Card>
          <Tabs />

          <Box
            sx={{
              '& .MuiPaper-root': {
                borderRadius: 0,
              },
            }}
          >
            <Outlet />
          </Box>
        </Card>
      </Container>
    </FosterFamilyListNavigatorContextProvider>
  );
};
